import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLES_DATA } from "./actionTypes";
import {
  fetchVehiclesSuccess,
  fetchVehiclesFailure,
} from "./actions";

function* fetchVehiclesDataSaga(data) {
  try {
    let url = process.env.REACT_APP_WEB_APP_URL + `/api/web/vehicles`;
    if (data.vehicleId) {
      url += `?vehicleId=${data.vehicleId}`;
    }
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesFailure(error.message));
  }
}

export default function* vehiclesSaga() {
  yield takeEvery(FETCH_VEHICLES_DATA, fetchVehiclesDataSaga);
}
